/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import InlineEditor from '@ckeditor/ckeditor5-editor-inline/src/inlineeditor.js';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold.js';
import Code from '@ckeditor/ckeditor5-basic-styles/src/code.js';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials.js';
import FindAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/findandreplace.js';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic.js';
import Link from '@ckeditor/ckeditor5-link/src/link.js';
import List from '@ckeditor/ckeditor5-list/src/list.js';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph.js';
import Subscript from '@ckeditor/ckeditor5-basic-styles/src/subscript.js';
import Superscript from '@ckeditor/ckeditor5-basic-styles/src/superscript.js';
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline.js';

import Reference from './reference/reference';

function ItalicAsEmPlugin( editor ) {
	editor.conversion.for( 'downcast' ).attributeToElement( {
		model: 'italic',
		view: 'em',
		converterPriority: 'high'
	} );
}

class Editor extends InlineEditor {}

// Plugins to include in the build.
Editor.builtinPlugins = [
	Bold,
	Code,
	Essentials,
	FindAndReplace,
	Italic,
	Link,
	List,
	Paragraph,
	Subscript,
	Superscript,
	Underline,
    Reference,
	ItalicAsEmPlugin
];

// Editor configuration.
Editor.defaultConfig = {
	toolbar: {
		items: [
			'bold',
			'italic',
			'underline',
			'subscript',
			'superscript',
			'link',
			'reference',
			'code',
			'bulletedList',
			'numberedList',
			'|',
			'findAndReplace',
		]
	},
	language: 'fr'
};

export default Editor;
